/* ------------------------------------------------------------------------ *\
 * PWA
\* ------------------------------------------------------------------------ */

import pwaInstallPrompt from "pwa-install-prompt";

new pwaInstallPrompt();
